import { render, staticRenderFns } from "./SettlementsByPayee.vue?vue&type=template&id=244bc17f&"
import script from "./SettlementsByPayee.vue?vue&type=script&lang=js&"
export * from "./SettlementsByPayee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports